function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.798828 4.83592C0.798828 3.40023 1.9649 2.23637 3.40333 2.23637H9.19112C9.56404 2.23637 9.86636 2.53811 9.86636 2.91033C9.86636 3.28254 9.56404 3.58428 9.19112 3.58428H3.40333C2.71076 3.58428 2.14931 4.14466 2.14931 4.83592V13.9825C2.14931 14.6737 2.71075 15.2341 3.40333 15.2341H11.6027C12.2953 15.2341 12.8567 14.6737 12.8567 13.9825V9.1685C12.8567 8.79628 13.159 8.49454 13.532 8.49454C13.9049 8.49454 14.2072 8.79628 14.2072 9.1685V13.9825C14.2072 15.4182 13.0411 16.582 11.6027 16.582H3.40333C1.9649 16.582 0.798828 15.4182 0.798828 13.9825V4.83592Z",
  fill: "#172342"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1493 1.28273C17.0006 2.17209 17.0987 3.67349 15.9387 4.83131L8.58023 12.1758L5.36969 13.0913C4.71478 13.2781 4.1093 12.6737 4.29642 12.0201L5.21372 8.81565L12.5722 1.4712C13.1567 0.88779 13.8233 0.591591 14.4867 0.582258C15.145 0.572995 15.7336 0.848409 16.1493 1.28273ZM13.5271 2.42431L6.4161 9.5218L5.83344 11.5572L7.87274 10.9757L14.9838 3.87818C15.6428 3.22038 15.4998 2.55548 15.1728 2.21383C14.9994 2.03265 14.7646 1.9264 14.5057 1.93004C14.2518 1.93361 13.9072 2.0449 13.5271 2.42431Z",
  fill: "#172342"
});

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.91252443.svg";
export { ForwardRef as ReactComponent };